export const getLanguageFromUrl = () => {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname;
    const pathSegments = path.split('/').filter(Boolean);
    return pathSegments[0];
  }
  return 'sv';
};
